module.exports = __webpack_public_path__ + "static/media/5B.af2b1b9a.png";